import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  addProjectSlot,
  completeProjectSlot,
  deleteProjectSlot,
  getAvailableProjectSlots,
  getProjectSlots,
  purchaseSlot,
  updateProjectSlot,
  ProjectSlotFilters,
} from '../api';

export const useGetProjectSlots = (filters?: ProjectSlotFilters) => {
  return useQuery({
    queryKey: ['getProjectSlots', filters],
    queryFn: () => getProjectSlots(filters),
    staleTime: 0,
    cacheTime: 0,
    select: (data) => data.data.resource,
  });
};

export const useAddProjectSlot = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: addProjectSlot,
    onSuccess: () => {
      queryClient.invalidateQueries(['getProjectSlots']);
    },
    onError: (error) => {
      console.log({ error });
    },
  });
};

export const usePurchaseSlot = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: purchaseSlot,
    onSuccess: () => {
      queryClient.invalidateQueries(['getProjectSlots']);
      queryClient.invalidateQueries(['getMyProjectSlots']);
    },
    onError: (error) => {
      console.log({ error });
    },
  });
};

export const useDeleteProjectSlot = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteProjectSlot,
    onSuccess: () => {
      queryClient.invalidateQueries(['getProjectSlots']);
    },
  });
};

export const useUpdateProjectSlot = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateProjectSlot,
    onSuccess: () => {
      queryClient.invalidateQueries(['getProjectSlots']);
    },
  });
};

export const useGetAvailableProjectSlots = (filters?: ProjectSlotFilters) => {
  return useQuery({
    queryKey: ['getAvailableProjectSlots', filters],
    queryFn: () => getAvailableProjectSlots(filters),
    staleTime: 0,
    cacheTime: 0,
    select: (data) => data.data.resource,
  });
};

export const useCompleteProjectSlot = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => completeProjectSlot(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getProjectSlots'] });
    },
  });
};
